
/* Keep Shopify menu management unchanged while hiding only "All Auto Parts" links. */
(() => {
  const hideRemovedMenuItem = () => {
    document.querySelectorAll('header a, header-drawer a, .header a, .menu-drawer a, nav a').forEach(link => {
      if (link.textContent.trim().replace(/\s+/g, ' ').toLowerCase() !== 'all auto parts') return;
      const item = link.closest('li, .menu-list__list-item, .menu-drawer__menu-item') || link;
      item.hidden = true;
      item.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('h1').forEach(title => {
      if (title.textContent.trim().toLowerCase() === 'all auto parts') title.hidden = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideRemovedMenuItem);
  else hideRemovedMenuItem();
  const observer = new MutationObserver(hideRemovedMenuItem);
  observer.observe(document.documentElement, {childList:true,subtree:true});
})();
